import { legacyVehicleModelId } from "../shared/customerVehiclesV1Model";
export function legacyVehicleDraft(vehicle) {
  return {
    brand_id: vehicle.brand ?? null, model_id: legacyVehicleModelId(vehicle), variant: vehicle.variant || "", year: vehicle.year ? String(vehicle.year).slice(0, 4) : null,
    vin: vehicle.vin || "", engine_code: vehicle.engine_code || "", engine_displacement: vehicle.engine_displacement != null ? String(vehicle.engine_displacement) : "",
    engine_layout: vehicle.engine_layout || null, transmission_type: vehicle.transmission_type || null, transmission_code: vehicle.transmission_code || "",
    drivetrain: vehicle.drivetrain || null, fuel_type: vehicle.fuel_type || null, country_spec: vehicle.country_spec || null, trim_info: vehicle.trim_info || "",
    notes: vehicle.additional_notes || vehicle.notes || "", is_primary: Number(vehicle.is_primary_vehicle) === 1, status: vehicle.status !== 0,
  };
}
export function buildLegacyVehiclePayload(vehicleSubForm, editingVehicleId, customerId, actorId) {
  const isEdit = !!editingVehicleId;
    const vf = vehicleSubForm;
      const payload = isEdit
        ? { id: editingVehicleId }
        : { customer_id: customerId, brand: vf.brand_id, model: vf.model_id, created_by: actorId };
        payload.brand = vf.brand_id;
        payload.model = vf.model_id;
        payload.is_primary_vehicle = vf.is_primary ? 1 : 0;
        payload.status = vf.status ? 1 : 0;
        payload.variant = vf.variant || null;
        payload.year = vf.year || null;
        payload.vin = vf.vin || null;
        payload.engine_code = vf.engine_code || null;
        payload.engine_displacement = vf.engine_displacement ? parseFloat(vf.engine_displacement) : null;
        payload.engine_layout = vf.engine_layout || null;
        payload.transmission_type = vf.transmission_type || null;
        payload.transmission_code = vf.transmission_code || null;
        payload.drivetrain = vf.drivetrain || null;
        payload.fuel_type = vf.fuel_type || null;
        payload.country_spec = vf.country_spec || null;
        payload.trim_info = vf.trim_info || null;
        payload.additional_notes = vf.notes || null;
  
  return payload;
}
